import { FieldOrigin, FieldTypeEnum } from '@models/module/fields/enums';
import { FieldModel } from '@models/module/fields/main';

type FieldCard = Partial<Pick<FieldModel, 'typeId' | 'fieldOrigin' | 'isContractSystemField'>>;

export const fieldCardBackground = (field: FieldCard): string => {
  if (field.typeId === FieldTypeEnum.Annotation) {
    return 'var(--white)';
  }
  if (field.isContractSystemField) {
    return 'var(--warn-50)';
  }
  switch (field.fieldOrigin) {
    case FieldOrigin.Relation:
      return 'var(--accent-100)';
    case FieldOrigin.Property:
      return 'var(--primary-100)';
    default:
      return 'var(--white)';
  }
};
